class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(
      `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
    ).forEach((element) => {
      element.classList.remove('active');
    });

    const activeMedia = this.querySelector(
      `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
    );

    if (!activeMedia) return;

    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');

    if (container) {
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
    }

    if (
      activeMedia.nodeName === 'DEFERRED-MEDIA' &&
      activeMediaContent &&
      activeMediaContent.querySelector('.js-youtube')
    ) {
      activeMedia.loadContent();
    }
  }
}

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
}

var scrollToElement = function (element) {
  if (!element) return;

  var $innerListItem = $(element);
  var $parentDiv = $(element).parent();

  if (!$innerListItem.length || !$parentDiv.length) return;

  $parentDiv.scrollTop(
    $parentDiv.scrollTop() +
      $innerListItem.position().top -
      $parentDiv.height() +
      $innerListItem.height()
  );
};

var setNavHeight = function () {
  setTimeout(function () {
    var $firstImage = $('.productwithtext-carousel').find('.slick-slide[data-slick-index=0] img');
    var $buttons = $('.carousel-btn');

    if (!$firstImage.length || !$buttons.length) return;

    $('.carousel-nav-list').height($firstImage.height() - $buttons.height() * 2);
  }, 250);
};

(function () {
  'use strict';

  const MAIN_PRODUCT_ID = 43500567298234;
  const MAIN_SELLING_PLAN = 2890825914;

  const PACK_TO_MAIN_QTY = {
    '1': 1,
    '3': 3,
    '6': 6
  };

  const PRICING = {
    onetime: {
      1: { total: 43.94, regular: 43.94, savingText: 'Save 65% Today', atcPrice: 43.94 },
      3: { total: 119.85, regular: 110.85, savingText: 'Save $125.95 Today', atcPrice: 110.85 },
      6: { total: 239.7, regular: 199.97, savingText: 'Save $178.45 Today', atcPrice: 199.97 }
    },
    subscription: {
      1: { total: 43.94, regular: 39.95, savingText: 'Save 68% Today', atcPrice: 39.95 },
      3: { total: 119.85, regular: 104.85, savingText: 'Save 68% Today', atcPrice: 104.85 }
    }
  };

  const DISCOUNT_BY_PACK = {
    subscription: {
      '1': 'HAPPYDROPS1SUBSCRIPTION',
      '3': 'HAPPYDROPS3SUBSCRIPTION',
      '6': 'HAPPYDROPS6SUBSCRIPTION'
    },
    onetime: {
      '1': 'HAPPYDROPS1ONETIME',
      '3': 'HAPPYDROPS3ONETIME',
      '6': 'HAPPYDROPS6ONETIME'
    }
  };

  const FREE_PRODUCTS = [43962704691386, 32446618271819, 40470470492346];

  const ALLOWED_VARIANTS_FOR_ONETIME_UI = new Set(['40629348073658', '41127238860986']);

  const $totalPrice = $('.total-price');
  const $regularPrice = $('.regular-price');
  const $savingText = $('.saving-text');
  const $atcTotalPrice = $('.atc-btn--total_price');
  const $atcRegularOneTime = $('.regular-price-one-time.atc-btn-price');

  function money(n) {
    const num = Number(n);
    if (Number.isNaN(num)) return '$0.00';
    return '$' + num.toFixed(2);
  }

  function getSelectedPackValue() {
    const $checked = $('#qtyOptions input.favour_input:checked');
    if ($checked.length) return String($checked.val());

    const $checkedGlobal = $('input.favour_input:checked');
    return $checkedGlobal.length ? String($checkedGlobal.val()) : '1';
  }

  function getSelectedPurchaseType() {
    const val = $('input[name="purchase_type"]:checked').val();
    return val === 'subscription' ? 'subscription' : 'onetime';
  }

  function getSelectedVariantId() {
    const val = $('#ddlProducts').find(':selected').val();
    return val ? String(val) : '';
  }

  function getMainQtyFromPack(packValue) {
    return PACK_TO_MAIN_QTY[packValue] || 1;
  }

  function applyPricing(plan, mainQty) {
    const planPricing = PRICING[plan] && PRICING[plan][mainQty];

    if (!planPricing) {
      console.warn('[HD] Pricing not found for', { plan, mainQty });
      return;
    }

    $totalPrice.text(money(planPricing.total));
    $regularPrice.text(money(planPricing.regular));
    $savingText.text(planPricing.savingText);
    $atcTotalPrice.text('(' + money(planPricing.atcPrice) + ')');

    const onetimeRegular =
      (PRICING.onetime[mainQty] && PRICING.onetime[mainQty].regular) || planPricing.regular;

    $atcRegularOneTime.text(money(onetimeRegular) + ' ');
  }

  function syncQtyUIToPack(packValue) {
    $('#qtyOptions li').removeClass('selected');
    $('#qtyOptions input[type="radio"]').prop('checked', false);

    const $li = $('#qtyOptions li').has('input.favour_input[value="' + packValue + '"]');

    if ($li.length) {
      $li.addClass('selected');
      $li.find('input[type="radio"]').prop('checked', true);
    }
  }

  function updateUIFromState() {
    const packValue = getSelectedPackValue();
    const plan = getSelectedPurchaseType();
    const mainQty = getMainQtyFromPack(packValue);

    applyPricing(plan, mainQty);
  }

  $(document).on('click', '.freq-option', function () {
    $('.freq-option').removeClass('selecteds');
    $(this).addClass('selecteds');

    const isSubscriptionTab = $(this).hasClass('subscripts');

    if (isSubscriptionTab) {
      $('.bag6').hide();
    } else {
      $('.bag6').show();

      const variantId = getSelectedVariantId();
      if (!ALLOWED_VARIANTS_FOR_ONETIME_UI.has(variantId)) {
        // preserve original behavior
      }
    }

    updateUIFromState();
  });

  $(document).on('click', '#qtyOptions li', function () {
    $('#qtyOptions li').removeClass('selected');
    $('#qtyOptions input[type="radio"]').prop('checked', false);

    $(this).addClass('selected');
    $(this).find('input[type="radio"]').prop('checked', true);

    updateUIFromState();
  });

  $(document).on('change', '#ddlProducts', function () {
    const sel = String($(this).find(':selected').val() || '');

    if (sel === 'bundle-3') {
      syncQtyUIToPack('3');
    } else if (sel === 'bundle-6') {
      syncQtyUIToPack('6');
    } else {
      syncQtyUIToPack('1');
      $('#qtyOptions li.bag6,#qtyOptions li.bag1,#qtyOptions li.bag3,.subscripts').css(
        'display',
        'block'
      );
    }

    updateUIFromState();
  });

  function buildCheckoutUrl() {
    const qtyInput = document.querySelector('input[name="quantity"]:checked');
    const purchaseTypeValue = $('input[name="purchase_type"]:checked').val();
    const packValue = qtyInput ? String(qtyInput.value) : '1';
    const mainQty = getMainQtyFromPack(packValue);

    const purchaseType = purchaseTypeValue === 'subscription' ? 'subscription' : 'onetime';

    const shippingDiscount = purchaseTypeValue === 'subscription' ? 'HAPPYDROPSFB' : '';

    const discountCode =
      (DISCOUNT_BY_PACK[purchaseType] && DISCOUNT_BY_PACK[purchaseType][packValue]) || null;

    const cartItems = [
      { id: MAIN_PRODUCT_ID, quantity: mainQty },
    ];

    if (purchaseType === 'subscription') {
      cartItems[0].selling_plan = MAIN_SELLING_PLAN;
    }

    const addParams = new URLSearchParams();

    cartItems.forEach((item) => {
      if (!item || !item.id || !item.quantity) return;

      addParams.append('items[][id]', String(item.id));
      addParams.append('items[][quantity]', String(item.quantity));

      if (item.selling_plan) {
        addParams.append('items[][selling_plan]', String(item.selling_plan));
      }

      if (item.properties) {
        Object.keys(item.properties).forEach((key) => {
          addParams.append(`items[][properties][${key}]`, String(item.properties[key]));
        });
      }
    });

    let returnToCheckout = '/checkout';

    if (discountCode) {
      returnToCheckout += `?discount=${encodeURIComponent(discountCode)}`;
    }

    addParams.append('return_to', returnToCheckout);

    const clearParams = new URLSearchParams();
    clearParams.set('return_to', '/cart/add?' + addParams.toString());

    return window.location.origin + '/cart/clear?' + clearParams.toString();
  }

  function bindCheckoutRedirect() {
    const atcBtn = document.getElementById('addToCartBtn');

    if (!atcBtn) {
      console.warn('[HD] addToCartBtn not found.');
      return;
    }

    if (atcBtn.dataset.hdBound === '1') return;
    atcBtn.dataset.hdBound = '1';

    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const url = buildCheckoutUrl();
      window.location.href = url;
    });
  }

  function initHappyDrops() {
    updateUIFromState();
    bindCheckoutRedirect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHappyDrops);
  } else {
    initHappyDrops();
  }
})();

